import { Button, InputNumber, Select, Space, Switch, TimePicker } from "antd";
import React, { memo, useEffect, useState } from "react";
import { TEXT_DEF } from "../../../constant/text";
import moment from "moment";
import "antd/dist/antd.css";
import dayjs from "dayjs";

const TicketThree = ({
  pointMoney,
  roundArray,
  maintenanceTicket3,
  authConfig,
  setAuthConfig,
  onShowModalConfirm,
  onHandleInputChangePoint,
  onHandleChangeInputRound,
  onHandleAddRowMoney,
  onHandleRemoveItem,
  onHandleAddRound,
  onHandleRemoveItemRound,
  onHandleUpdateMainTiket3,
  onHandleUpdateAuthTiket3,
  setMaintenaaceTicket3,
  time,
  setTime,
  onSetTime,
  onShowModal,
  totalDeposit,
  setTotalDeposit,
}) => {
  return (
    <div className="col-12">
      <div className="col-9" style={{ display: "flex", alignItems: "center" }}>
        <div className="col-3">{TEXT_DEF.text0057}:</div>
        <div className="col-6" style={{ display: "flex" }}>
          <Switch
            checkedChildren="Bật"
            unCheckedChildren="Tắt"
            checked={maintenanceTicket3?.value}
            style={{ width: 80, marginTop: "5px" }}
            onChange={(e) =>
              setMaintenaaceTicket3((prev) => ({
                ...prev,
                value: e,
              }))
            }
          />
          <Button
            type="primary"
            onClick={(e) => onShowModal(e, "maintiket3")}
            style={{
              marginLeft: "2rem",
            }}
          >
            {TEXT_DEF.update}
          </Button>
        </div>
      </div>
      <div
        className="col-9 mt-3"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="col-3">{TEXT_DEF.text_fake}:</div>
        <div className="col-6" style={{ display: "flex" }}>
          <Switch
            checkedChildren="Bật"
            unCheckedChildren="Tắt"
            checked={authConfig?.value}
            style={{ width: 80, marginTop: "5px" }}
            onChange={(e) =>
              setAuthConfig((prev) => ({
                ...prev,
                value: e,
              }))
            }
          />
          <Button
            type="primary"
            onClick={(e) => onShowModal(e, "authConfig3")}
            style={{
              marginLeft: "2rem",
            }}
          >
            {TEXT_DEF.update}
          </Button>
        </div>
      </div>
      <div
        className="col-9 mt-5"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="col-3">{TEXT_DEF.time_pzize}:</div>
        <div className="col-6">
          <Space>
            <TimePicker
              size="large"
              value={time.value ? moment(time.value, "HH:mm:ss") : null}
              onChange={(value) => {
                if (value !== null && value !== undefined) {
                  setTime({
                    ...time,
                    value: moment(value).format("HH:mm:ss"),
                  });
                } else {
                  setTime({
                    ...time,
                    value: null,
                  });
                }
              }}
            />
          </Space>
          <Button
            type="primary"
            style={{ marginLeft: "2rem" }}
            onClick={(e) => onShowModal(e, "configtime3")}
          >
            {TEXT_DEF.text0012}
          </Button>
        </div>
      </div>
      <div
        className="col-9 mt-5"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="col-3">{TEXT_DEF.text0060}:</div>
        <div className="col-6" style={{ display: "flex" }}>
          <InputNumber
            min={0}
            value={totalDeposit.value}
            onChange={(e) => setTotalDeposit((item) => ({ ...item, value: e }))}
            className="flex w-full"
          />
          <Button
            type="primary"
            onClick={(e) => onShowModal(e, "totalDeposit")}
            style={{
              marginLeft: "2rem",
            }}
          >
            {TEXT_DEF.update}
          </Button>
        </div>
      </div>
      <div
        className="col-12 mt-5"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="col-3">{TEXT_DEF.text_money}:</div>
        <div
          className="col-9 gap-2"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {pointMoney &&
            pointMoney.map((item, index) => (
              <div style={{ display: "flex" }} key={item.id}>
                <div className="col-3" style={{ display: "flex" }}>
                  <div>{TEXT_DEF.point}:</div>
                  <InputNumber
                    type="number"
                    min={0}
                    value={item.value}
                    defaultValue={0}
                    max={9999}
                    style={{ width: "50%", marginLeft: "1rem" }}
                    onChange={(e) =>
                      onHandleInputChangePoint(e, item.id, "value")
                    }
                  />
                </div>
                <div className="col-3" style={{ display: "flex" }}>
                  <div>{TEXT_DEF.percent}:</div>
                  <InputNumber
                    type="number"
                    defaultValue={0}
                    value={item.value1}
                    min={0}
                    max={9999}
                    style={{ marginLeft: "1rem", width: "50%" }}
                    onChange={(e) =>
                      onHandleInputChangePoint(e, item.id, "value1")
                    }
                  />
                </div>
                <div className="col-3" style={{ display: "flex" }}>
                  <Button
                    htmlType="button"
                    type="danger"
                    onClick={() => onHandleRemoveItem(item.id)}
                  >
                    Xóa
                  </Button>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="col-6 mt-3">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            htmlType="button"
            type="primary"
            style={{
              marginRight: "1rem",
            }}
            onClick={onHandleAddRowMoney}
          >
            {TEXT_DEF.add}
          </Button>
        </div>
      </div>
      <div
        className="col-12 mt-5"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="col-3">{TEXT_DEF.round}:</div>
        <div
          className="col-9 gap-2"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {roundArray &&
            roundArray.map((item) => (
              <div style={{ display: "flex" }} key={item.id}>
                <div className="col-3" style={{ display: "flex" }}>
                  <div>{TEXT_DEF.number_round}:</div>
                  <InputNumber
                    type="number"
                    min={0}
                    defaultValue={0}
                    value={item.value}
                    max={9999}
                    style={{ width: "50%", marginLeft: "1rem" }}
                    onChange={(e) =>
                      onHandleChangeInputRound(e, item.id, "value")
                    }
                  />
                </div>
                <div className="col-3" style={{ display: "flex" }}>
                  <div>{TEXT_DEF.percent}:</div>
                  <InputNumber
                    type="number"
                    defaultValue={0}
                    min={0}
                    value={item.value1}
                    max={9999}
                    style={{ marginLeft: "1rem", width: "50%" }}
                    onChange={(e) =>
                      onHandleChangeInputRound(e, item.id, "value1")
                    }
                  />
                </div>
                <div className="col-3" style={{ display: "flex" }}>
                  <Button
                    htmlType="button"
                    type="danger"
                    onClick={() => onHandleRemoveItemRound(item.id)}
                  >
                    Xóa
                  </Button>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="col-6 mt-3">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            htmlType="button"
            type="primary"
            style={{
              marginRight: "1rem",
            }}
            onClick={onHandleAddRound}
          >
            {TEXT_DEF.add}
          </Button>
        </div>
      </div>
      <div
        className="col-12 mt-5"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          htmlType="submit"
          type="primary"
          onClick={(e) => onShowModalConfirm(e, "ticket3")}
        >
          {TEXT_DEF.update}
        </Button>
      </div>
    </div>
  );
};

export default memo(TicketThree);
